export default "__VITE_ASSET__CvTjfTpa__"